<template>
  <div v-if="author" class="max-w-screen-md">
    <div class="border-b border-gray-400">
      <div class="flex items-center justify-between transition duration-300 cursor-pointer" @click="open = !open">
        <div class="shrink-0">
          <CldnImg
            v-if="author.image[0]"
            :src="author.image[0].url"
            sizes="48px"
            :ratio="1"
            class="w-12 h-12 mx-auto mr-4 rounded-full"
            :alt="author.image[0].title"
          />
        </div>
        <div class="py-6 pr-2 mr-auto fluid-lg leading-tight font-medium">
          {{ author.title }}
        </div>
        <div class="sm:block hidden fluid-xs leading-tightest font-medium">
          {{ $t('authorInformation') }}
        </div>
        <button class="w-1 p-4 -mt-1 fluid-lg leading-tight font-medium">{{ indicator }}</button>
      </div>
      <Expandable :open="open">
        <div class="mt-4 fluid-lg leading-tight font-medium">{{ author.claim }}</div>
        <div class="text-copy fluid-base leading-relaxed font-light mt-4" v-html="author.teaserText"></div>
        <nuxt-link
          :to="$localeRootPath(author.uri)"
          class="md:my-8 btn-pill-white inline-block my-4 fluid-xs leading-tightest"
          >{{ $t('viewProfile') }}</nuxt-link
        >
      </Expandable>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import CldnImg from '@/components/CldnImg';
import Expandable from '@/components/common/Expandable';

export const AuthorInformationFragment = gql`
  fragment AuthorInformationFragment on expert_Entry {
    title
    uri
    teaserText
    claim
    image {
      url
      title
    }
  }
`;
export default defineNuxtComponent({
  components: {
    Expandable,
    CldnImg,
  },
  props: {
    author: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      open: false,
    };
  },
  computed: {
    indicator() {
      return this.open ? '-' : '+';
    },
  },
});
</script>
